import { render, staticRenderFns } from "./partner-detail.vue?vue&type=template&id=4177bbe0&"
import script from "./partner-detail.vue?vue&type=script&lang=js&"
export * from "./partner-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports